<template>
  <div id="app">
    <Header v-if="$route.path !== '/sweden'" />
    <router-view/>
    <Footer v-if="$route.path !== '/sweden'" />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: "App",
  components: { Header, Footer }
};
</script>
